
import React, { useContext, useState } from "react";
import { FaEye } from "react-icons/fa";
import { ConvertEnglish } from "../../../../components/ConterEnglsih";
import LoadingButton from "../../../../components/LoadingButton";
import { GStore } from "../../../../context/Context";

const CollectorModal = ({ handleAddCollector,register,handleSubmit,loading}) => {
    const {english} = useContext(GStore);
    const [passShow,setPassShow] = useState(false)
  return (
    <div>
      {/* Put this part before </body> tag */}
      <input type="checkbox" id="add-collector-modal" className="modal-toggle" />
      <label htmlFor="add-collector-modal" className="modal cursor-pointer">
        <label className="modal-box relative" htmlFor="">
          <h3 className="text-lg font-bold">
          <ConvertEnglish english={"ADD A NEW collector"} bangla={"নতুন কালেক্টর সংযোগ করুন"} />
          </h3>
          <div className="my-5">
          <form onSubmit={handleSubmit(handleAddCollector)}>

          <input type="text" {...register("name")} placeholder={english ? "Name" : "নাম"} className="input input-bordered w-full " required/>

          <input type="text" {...register("address")} placeholder={english ? "Address" : "টিকানা"} className="input input-bordered w-full mt-5" required />

          <input type="number" {...register("number")} placeholder={english ? "Number" : "নাম্বার"} className="input input-bordered w-full mt-5" required/>
          <div className='relative'>
        <input type={passShow  ?"text" :"password" } {...register("pass")} placeholder="পাসওয়ার্ড" className="input input-bordered w-full mt-5" required />
        <button type='button' onClick={()=>setPassShow(!passShow)} className='btn btn-ghost absolute right-0 top-5'><FaEye size={24}></FaEye></button>
        </div>
          {
            loading ? <div className="mt-5">
        <LoadingButton text={"সংযোগ করুন"}></LoadingButton>
            </div> : <div className="mt-5">
         <button type="submit" className="btn btn-outline w-full"><ConvertEnglish english={"ADD collector"} bangla={"সংযোগ করুন"} /></button>
            </div>
          }
            
          </form>
          </div>
        </label>
      </label>
    </div>
  );
  }
  export default CollectorModal;